import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=49b49cc2&scoped=true&"
import script from "./CartView.vue?vue&type=script&lang=ts&"
export * from "./CartView.vue?vue&type=script&lang=ts&"
import style0 from "./CartView.vue?vue&type=style&index=0&id=49b49cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b49cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b49cc2')) {
      api.createRecord('49b49cc2', component.options)
    } else {
      api.reload('49b49cc2', component.options)
    }
    module.hot.accept("./CartView.vue?vue&type=template&id=49b49cc2&scoped=true&", function () {
      api.rerender('49b49cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CartView.vue"
export default component.exports